import * as Icones from '../atoms/Icon';

/**
 * Cartão de recurso. O ícone chega pelo NOME, e não como componente, porque
 * quem escreve o `content/site.js` está escrevendo texto — obrigar um `import`
 * ali dentro devolveria código para o arquivo que existe justamente para não
 * ter nenhum.
 *
 * Nome desconhecido não quebra a página: o cartão sai sem o quadradinho, e o
 * que se perde é a ilustração, não o recurso descrito.
 */
function FeatureCard({ icone, variante = 'purple', titulo, texto }) {
  const Icone = Icones[icone];

  return (
    <div className="feature-card">
      {Icone && (
        <span className={`feature-icon${variante === 'purple' ? '' : ` feature-icon--${variante}`}`}>
          <Icone size={21} />
        </span>
      )}
      <h3 className="feature-title">{titulo}</h3>
      <p className="feature-text">{texto}</p>
    </div>
  );
}

export default FeatureCard;
